var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6539 4.96154C11.845 4.96154 12 4.80655 12 4.61539V2.76924C12 2.57806 11.845 2.4231 11.6539 2.4231H4.03847V4.15386C4.03847 4.34504 3.88348 4.50001 3.69232 4.50001C3.50116 4.50001 3.34617 4.34502 3.34617 4.15386V2.4231H0.346172C0.154992 2.4231 0 2.57806 0 2.76924V4.61539C0 4.80657 0.154992 4.96154 0.346148 4.96154C0.91875 4.96154 1.38462 5.42738 1.38462 6.00001C1.38462 6.57263 0.918773 7.03848 0.346148 7.03848C0.154992 7.03848 0 7.19345 0 7.38463V9.23078C0 9.42196 0.154992 9.57692 0.346148 9.57692H3.34615V7.84616C3.34615 7.65498 3.50114 7.50001 3.6923 7.50001C3.88345 7.50001 4.03845 7.655 4.03845 7.84616V9.57692H11.6538C11.845 9.57692 12 9.42193 12 9.23078V7.38463C12 7.19345 11.845 7.03848 11.6538 7.03848C11.0812 7.03848 10.6154 6.57263 10.6154 6.00001C10.6154 5.42738 11.0812 4.96154 11.6539 4.96154ZM4.03847 6.46154C4.03847 6.65272 3.88348 6.80769 3.69232 6.80769C3.50116 6.80769 3.34617 6.6527 3.34617 6.46154V5.53846C3.34617 5.34728 3.50116 5.19231 3.69232 5.19231C3.88348 5.19231 4.03847 5.3473 4.03847 5.53846V6.46154Z",
    fill: "#4F4F4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/voucher.6d362fb425fafe9c94545d84e4bd07a7.svg";
export { ForwardRef as ReactComponent };